// ids:
export function getNewId(items, parameter, ids = []) {
  let map = ids.concat(
    items.map((items) => {
      if (parameter in items) {
        return items[parameter];
      } else {
        return 1;
      }
    })
  );
  let min = Math.min(...map);
  let referencePointId = 0;
  if (min <= 0) {
    referencePointId = min - 1;
  }
  return referencePointId;
}
